// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__ebLB2","rotate":"styles_rotate__CXCLy","rotate-reverse":"styles_rotate-reverse__TfFIF"};